// Module
var code = "<div class=\"t-content c-tieredPricingTooltip\">\n    <div class=\"u-flex\">\n        <div ng-bind=\"context.label\"></div>\n        <div class=\"u-ml++\" ng-bind=\"context.balance | invCurrency: context.currencyCode:null:true\"></div>\n    </div>\n</div>";
// Exports
module.exports = code;